const agreementTypes = {
	FRAMEWORK: "framework",
	PRODUCTION: "production",
	CLOUD: "cloud",
};

export default agreementTypes;
